import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { PortalService } from '../services/portal.service';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  // if (!PortalService.Settings.portal_id || !AuthService.getAccessToken()) {
  //   window.location.href = 'https://brn.ai/hub/';
  // }

  // here
  canActivate(): boolean {

    console.log(window.location.hostname);
    if (!AuthService.getAccessToken() && environment.production) {
      // window.location.href = 'https://brn.ai/hub/';
      window.location.href = 'https://brn.ai';
      return false;
    } else if (!AuthService.getAccessToken() && (window.location.hostname === 'localhost')) {
      window.location.href = 'http://localhost:4200/auth/logout';
    } else if (!AuthService.getAccessToken() && !environment.production) {
      window.location.href = 'https://dev.brn.ai/v2/auth/logout';
    }
    return true;
  }
}
